import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { CouponListWrap } from '../../views/coupon-v2/list/CouponListWrap';
import { COUPON_PAGE_NAME } from '../../constants/service/app/couponConstants';

const CouponList = () => {
  return (
    <PageTemplate pageName={COUPON_PAGE_NAME.COUPON_LIST}>
      <CouponListWrap />
    </PageTemplate>
  );
};

export default CouponList;
